import { useCallback, useEffect, useState } from 'react';

import { FEATURE } from '~/common/enums/feature.enum';
import { useIsFeatureEnabled } from '~/hooks/useIsFeatureEnabled';

const siteKey = process.env.NEXT_PUBLIC_RECAPTCHA_KEY;

export function useRecaptcha() {
  const [isInitialized, setIsInitialized] = useState(false);
  const isRecaptchaEnabled = useIsFeatureEnabled(FEATURE.ENABLE_RECAPTCHA);

  const onLoadCallback = useCallback(() => {
    setIsInitialized(true);
  }, []);

  useEffect(() => {
    const scriptElement = document.createElement('script');
    scriptElement.src = `https://www.recaptcha.net/recaptcha/enterprise.js?render=${siteKey}`;
    scriptElement.onload = onLoadCallback;
    document.body.appendChild(scriptElement);

    return () => {
      document.body.removeChild(scriptElement);
    };
  }, [onLoadCallback]);

  const getRecaptchaToken = useCallback(async () => {
    if (!isRecaptchaEnabled || !isInitialized) {
      return;
    }

    return new Promise((resolve) => {
      // @ts-expect-error misses type definition
      grecaptcha.enterprise.ready(() => {
        // @ts-expect-error misses type definition
        grecaptcha.enterprise.execute(siteKey, { action: 'LOGIN' }).then((token: string) => {
          resolve(token);
        });
      });
    }) as Promise<string>;
  }, [isInitialized, isRecaptchaEnabled]);

  return {
    isInitialized,
    getRecaptchaToken,
  };
}
